var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * this Input component should only be use in the scope of this package
 * and should not consumed from outside
 */
import React, { cloneElement, useState, useRef } from 'react';
import cx from 'classnames';
import { CancelIcon } from '@move-ui/icons-asset-catalog';
import Clickable from '@move-ui/clickable';
import { mergeRefs } from '@move-web-essentials-utils/ref';
import styles from './Input.module.css';
export var Input = function (_a) {
    var _b;
    var iconLeft = _a.iconLeft, iconRight = _a.iconRight, className = _a.className, _c = _a.tabIndex, tabIndex = _c === void 0 ? 0 : _c, disabled = _a.disabled, _d = _a.isValid, isValid = _d === void 0 ? true : _d, isSuccess = _a.isSuccess, onFocus = _a.onFocus, onBlur = _a.onBlur, inputRef = _a.inputRef, onClear = _a.onClear, value = _a.value, iconContainerClassName = _a.iconContainerClassName, children = _a.children, isSuccessful = _a.isSuccessful, rest = __rest(_a, ["iconLeft", "iconRight", "className", "tabIndex", "disabled", "isValid", "isSuccess", "onFocus", "onBlur", "inputRef", "onClear", "value", "iconContainerClassName", "children", "isSuccessful"]);
    var ref = useRef(null);
    var _e = useState(false), focus = _e[0], setFocus = _e[1];
    var error = !(isValid || disabled);
    var handleOnClear = "".concat(value).length > 0 &&
        onClear &&
        (function () {
            var _a;
            onClear(value);
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
        });
    var renderIcon = function (iconClassName, iconElement) {
        var _a;
        return (React.createElement("div", { className: cx(styles.icon, iconClassName, iconContainerClassName) }, cloneElement(iconElement, {
            className: cx(iconElement.props.className, (_a = {}, _a[styles.error] = error, _a))
        })));
    };
    return (React.createElement("div", { className: cx(styles.input, (_b = {},
            _b[styles.disabled] = disabled,
            _b[styles.success] = isSuccess,
            _b[styles.error] = error,
            _b[styles.isSuccessful] = isSuccessful,
            _b[styles.focus] = focus,
            _b[styles.withIconLeft] = iconLeft,
            _b[styles.withIconRight] = iconRight || handleOnClear,
            _b), className), "data-focus": focus ? 'true' : 'false' },
        children,
        iconLeft && renderIcon(styles.iconLeft, iconLeft),
        React.createElement("input", __assign({ disabled: disabled, ref: mergeRefs(ref, inputRef), "aria-invalid": !isValid, value: value }, (disabled ? {} : { tabIndex: tabIndex }), rest, { onFocus: function (event) {
                setFocus(true);
                onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
            }, onBlur: function (event) {
                setFocus(false);
                onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
            } })),
        iconRight && !handleOnClear && renderIcon(styles.iconRight, iconRight),
        handleOnClear && (React.createElement(Clickable, { onClick: handleOnClear, className: cx(styles.icon, styles.iconRight), "data-testid": "ClearButton" },
            React.createElement(CancelIcon, null)))));
};
//# sourceMappingURL=Input.js.map